import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "DepositoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "DepositoPage",
            ss: ss,
            ajax: {
                "url": ss.indexDeposito(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Deposito', name: 'd.Deposito', title: 'Deposito' },
                { data: 'Monto', name: 'd.Monto', title: 'Monto' },
                { data: 'TipoPago', name: 'tp.TipoPago', title: 'Tipo Pago' },
                { data: 'Numero', name: 'f.Numero', title: 'Numero Factura' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            tiposPagos: [],
            facturas: [],
            deposito: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {

        getTiposPagos() {
            this.ss.listTipoPago().then(
                (result) => {
                    let response = result.data;
                    this.tiposPagos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },

        getFacturas() {
            this.ss.listFactura().then(
                (result) => {
                    let response = result.data;
                    this.facturas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },

        newDeposito() {
            this.deposito = {};
            this.$refs['frm-deposito'].show();
        },
        showDeposito(id) {
            this.isLoading=true;
            this.ss.showDeposito(id).then(
                (result) => {
                    let response = result.data;
                    this.deposito = response.data;
                    this.$refs['view-deposito'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editDeposito() {
            this.$refs['frm-deposito'].show();
            this.$refs['view-deposito'].hide();
        },
        cancelDeposito() {
            if (this.deposito.id) {
                this.$refs['view-deposito'].show();
            }
            this.$refs['frm-deposito'].hide();
        },
        saveDeposito() {
            this.ss.storeDeposito(this.deposito).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-deposito'].hide();
                    this.$refs['datatable-deposito'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteDeposito() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyDeposito(this.deposito)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-deposito'].hide();
                                this.$refs['datatable-deposito'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Deposito').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showDeposito(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }

        this.getTiposPagos();
        this.getFacturas();
    }
};
